import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col rounded-2xl border border-gold/35 bg-white p-5 shadow-[0_12px_30px_-24px_rgba(28,36,24,0.45)]" data-id="element-271" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-272" data-mp="3460ffgfaacl5">
        <img src={testimonial.img} alt={`Photo of ${testimonial.name}`} width={56} height={56} loading="lazy" decoding="async" className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-gold" data-id="element-273" data-mp="386kc6ivy3e6r" />
        <div className="min-w-0" data-id="element-274" data-mp="1ds9pafywuu3m">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-275" data-mp="1dtkrwcgmdvt5">
            <span className="text-sm font-bold text-plum" data-id="element-276" data-mp="htcnc4xpdlwh">{testimonial.name}</span>
            <span className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-277" data-mp="d24dj7sgnyis">
              {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-278" data-mp="83t4v0dwju25" data-mpi={k} />)}
            </span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-plum/55" data-id="element-279" data-mp="35hsahw835g8">
            <span data-id="element-280" data-mp="10rylpc1u4ywp">📍 {testimonial.location}</span>
            <span className="text-sm leading-none" aria-hidden="true" data-id="element-281" data-mp="10pchnme5l1j8">
              {testimonial.flag}
            </span>
          </div>
          <p className="mt-0.5 text-[11px] font-semibold text-grape" data-id="element-282" data-mp="qszm0iz1sdlu">✔ Verified buyer</p>
        </div>
      </figcaption>
      <blockquote className="mt-4 flex-1 border-t border-gold/25 pt-4 text-[15px] leading-relaxed text-plum/75" data-id="element-283" data-mp="ltmrdc1xq28p">
        “{testimonial.quote}”
      </blockquote>
    </motion.figure>;
}